import { useState } from "react";
import { ImageOff } from "lucide-react";
import { imageUrl } from "@/lib/lamka";

export const SafeImg = ({ src, alt = "", className = "", tile = true, compact = false, ...rest }) => {
  const url = imageUrl(src);
  const [failed, setFailed] = useState(null);
  if (!url || failed === url) {
    if (!tile) return null;
    return (
      <span data-testid="photo-unavailable" className="h-full w-full flex flex-col items-center justify-center gap-2 bg-[#F5EFE6] text-[#B38F46]">
        <ImageOff className={compact ? "h-4 w-4" : "h-7 w-7"} strokeWidth={1} />
        {!compact && <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#71717A]">Photo unavailable</span>}
      </span>
    );
  }
  return <img src={url} alt={alt} onError={() => setFailed(url)} className={className} {...rest} />;
};
